// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (min-width:950px){
    .customer-administrator-account-billing-account-container{
        width: 40vw;
    }
    .customer-administrator-account-billing-account-container p{
        margin: 4vh 0px;
        text-align: center;
        color: rgb(68, 68, 68);
    }
}
@media screen and (max-width:949px){
    .customer-administrator-account-billing-account-container{
        width: auto;
    }
    .customer-administrator-account-billing-account-container p{
        margin: 4vh 0px;
        text-align: center;
        color: rgb(68, 68, 68);
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/workspace_styles/CustomerAdministratorStyles/Accounts/BillingAccount.css"],"names":[],"mappings":"AAAA;IACI;QACI,WAAW;IACf;IACA;QACI,eAAe;QACf,kBAAkB;QAClB,sBAAsB;IAC1B;AACJ;AACA;IACI;QACI,WAAW;IACf;IACA;QACI,eAAe;QACf,kBAAkB;QAClB,sBAAsB;IAC1B;AACJ","sourcesContent":["@media screen and (min-width:950px){\n    .customer-administrator-account-billing-account-container{\n        width: 40vw;\n    }\n    .customer-administrator-account-billing-account-container p{\n        margin: 4vh 0px;\n        text-align: center;\n        color: rgb(68, 68, 68);\n    }\n}\n@media screen and (max-width:949px){\n    .customer-administrator-account-billing-account-container{\n        width: auto;\n    }\n    .customer-administrator-account-billing-account-container p{\n        margin: 4vh 0px;\n        text-align: center;\n        color: rgb(68, 68, 68);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
